var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z",
    fill: "#169448"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 14,
    height: 8,
    rx: 1,
    fill: "#169448"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5323 16H11.5023L11.9123 15.25C12.0373 15.025 12.1323 14.805 12.1323 14.805H12.1423C12.1423 14.805 12.2373 15.025 12.3623 15.25L12.7723 16H13.7473L12.6573 14.225L13.7523 12.425H12.7573L12.3623 13.16C12.2373 13.39 12.1423 13.62 12.1423 13.62H12.1323C12.1323 13.62 12.0323 13.385 11.9123 13.16L11.5223 12.425H10.5273L11.6173 14.225L10.5323 16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2464 16H16.5814V15.25H15.1214V12.425H14.2464V16Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7988 15.55C16.7988 15.55 17.2638 16.06 18.1038 16.06C18.9088 16.06 19.3638 15.545 19.3638 14.95C19.3638 13.82 17.7538 13.9 17.7538 13.45C17.7538 13.25 17.9538 13.17 18.1337 13.17C18.5638 13.17 18.9237 13.485 18.9237 13.485L19.2938 12.77C19.2938 12.77 18.9138 12.365 18.1438 12.365C17.4338 12.365 16.8788 12.8 16.8788 13.46C16.8788 14.56 18.4888 14.545 18.4888 14.97C18.4888 15.185 18.2938 15.255 18.1138 15.255C17.6638 15.255 17.2588 14.885 17.2588 14.885L16.7988 15.55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileXls);
export default __webpack_public_path__ + "static/media/file_XLS.8a142a282eb381ddf3274ec86a267bab.svg";
export { ForwardRef as ReactComponent };